import React from 'react';
import {
  Container,
  FormContact,
  HoverLine,
  Htag,
  HtagVariant,
  Paragraph,
  ServiceCardList,
} from '../../components';
import styles from './contact-page.module.css';

export default function ContactPage() {
  return (
    <section
      className={styles.main}
      itemScope
      itemType="http://schema.org/Organization"
    >
      <Container>
        <Htag tag="h2" className={styles.title} variant={HtagVariant.h2}>
          NEED A RELIABLE PERFORMER FOR YOUR PROJECT?
        </Htag>
        <Htag tag="h5" className={styles.subtitle} variant={HtagVariant.h5}>
          Drop us a line and we&apos;ll contact you very soon!
        </Htag>
        <section className={styles.inner}>
          <div className={styles.inner__left}>
            <Paragraph className={styles.text__light}>
              Services we offer
            </Paragraph>
            <ServiceCardList />
            <FormContact />
          </div>
          <div className={styles.inner__right}>
            <div className={styles['inner__right-text']}>
              <Paragraph className={styles.text__light}>
                Please, leave a short message about your idea or feel free to
                contact us directly using the credentials below.
              </Paragraph>
            </div>
            <div className={styles['inner__right-info']}>
              <HoverLine>
                <a
                  className={styles['inner__right-email']}
                  href="mailto:victoria@mavinx.com"
                  itemProp="email"
                >
                  victoria@mavinx.com
                </a>
              </HoverLine>
              <HoverLine>
                <a
                  itemProp="telephone"
                  href="tel:+34692822185"
                  className={styles['inner__right-phone']}
                >
                  +34 692 822 185
                </a>
              </HoverLine>
            </div>
          </div>
        </section>
      </Container>
    </section>
  );
}
